import { Skeleton } from "@/components/ui/skeleton";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";
import { useServiceOptions } from "@/hooks/useServices";
import ServiceOptionCard from "./ServiceOptionCard";

interface ServiceOptionsListProps {
  serviceId: string;
}

export default function ServiceOptionsList({ serviceId }: ServiceOptionsListProps) {
  const { data: serviceOptions, loading, error } = useServiceOptions(serviceId);

  if (loading) {
    return (
      <div className="space-y-2">
        {[1, 2].map((i) => (
          <Skeleton key={i} className="h-20" />
        ))}
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="destructive" className="py-2">
        <AlertCircle className="h-3 w-3" />
        <AlertDescription className="text-xs">
          Failed to load service options
        </AlertDescription>
      </Alert>
    );
  }

  if (!serviceOptions || serviceOptions.length === 0) {
    return (
      <p className="text-sm text-muted-foreground text-center py-4">
        No service options added yet
      </p>
    );
  }

  return (
    <div className="space-y-2">
      {serviceOptions.map((serviceOption) => (
        <ServiceOptionCard key={serviceOption.id} serviceOption={serviceOption} />
      ))}
    </div>
  );
}